import CryptoJS from "crypto-js";
import { useEffect, useMemo, useState } from "react";
import ym from "react-yandex-metrika";

export const checkSwipeDirection = (e, startX, startY) => {
    let dir = "";
    let pageX = e.touches[0].pageX;
    let pageY = e.touches[0].pageY;

    let distX = pageX - startX;
    let distY = pageY - startY;

    if (Math.abs(distX) > Math.abs(distY)) {
        dir = distX < 0 ? "left" : "right";
    } else {
        dir = distY < 0 ? "up" : "down";
    }

    return dir;
};

export const isEmpty = (obj) => {
    for (let key in obj) {
        // если тело цикла начнет выполняться - значит в объекте есть свойства
        return false;
    }
    return true;
};

export const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const useAbTestComponent = ({ init, abTests, defaultComponent, matchValue }) => {
    const matchKey = useMemo(() => {
        for (const key in abTests) {
            if (init?.data?._ab_m?.[key]?._d?.colorHeader === matchValue) return key;
        }
        return null;
    }, [abTests, init, matchValue]);

    const [abComponent, setAbComponent] = useState(null);

    useEffect(() => {
        let isActive = true;

        if (!matchKey) {
            setAbComponent(null);
            return () => (isActive = false);
        }

        const loader = abTests[matchKey];
        if (typeof loader === "function") {
            loader().then((mod) => {
                if (isActive) {
                    setAbComponent(() => mod.default || mod);
                }
            });
        } else {
            setAbComponent(() => loader);
        }

        return () => (isActive = false);
    }, [abTests, matchKey]);

    return abComponent || defaultComponent;
};

export const intToString = (value) => {
    const suffixes = ["", "k", "m", "b", "t"];
    const suffixNum = Math.floor(("" + value).length / 3);
    let shortValue = parseFloat((suffixNum != 0 ? value / Math.pow(1000, suffixNum) : value).toPrecision(2));
    if (shortValue % 1 != 0) {
        shortValue = shortValue.toFixed(1);
    }
    return shortValue + suffixes[suffixNum];
};

export const getElemHeight = (id) => {
    const elem = document.getElementById(id);
    if (elem) return elem.clientHeight;
};

export const scrollOffsetTop = (id) => {
    const elem = document.getElementById(id);
    if (elem) return elem.offsetTop;
};

const buildNestedObject = (keysAndValues, index = 0) => {
    if (index === keysAndValues.length - 1) {
        const { key } = keysAndValues[index];
        return key ? `${key}` : ""; // Последний уровень — пустая строка
    }

    const { key, value } = keysAndValues[index];
    return { [key]: buildNestedObject(keysAndValues, index + 1) };
};

export const sendMetric = (goalName, metricData) => {
    const keysAndValues = [
        { key: metricData.params1 || "ris_promo", value: metricData.params1 },
        { key: goalName, value: goalName },
        { key: metricData.params2, value: metricData.params2 },
        { key: metricData.params3, value: metricData.params3 },
        { key: metricData.params4, value: metricData.params4 },
        { key: metricData.params5, value: metricData.params5 },
        { key: metricData.params6, value: metricData.params6 },
        { key: metricData.params7, value: metricData.params7 },
        { key: metricData.params8, value: metricData.params8 },
        { key: metricData.params9, value: metricData.params9 },
    ].filter(({ key }) => key !== undefined);

    const metric = { reachGoal: buildNestedObject(keysAndValues) };

    ym("reachGoal", goalName, metric);
};

export const getWhatId = () => {
    const location_search = window?.location?.search || "";
    const urlParams = new URLSearchParams(location_search);
    let what_id = urlParams.get("what_id") || null;

    if (!what_id && location_search) {
        let firstIndex = location_search.indexOf("what_id=");
        if (firstIndex >= 0) {
            firstIndex = firstIndex + 8;
            const lastIndex = firstIndex + 24;
            what_id = location_search.substring(firstIndex, lastIndex);
        }
    }

    return what_id;
};

export const pluralForm = (n, arrType = []) => {
    return arrType[n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2];
};

export function getSqlServerGuidHash(offerCode, vendorId) {
    const code = offerCode ?? "!@#D";
    const vendor = vendorId ?? "!@#T";
    const combined = code + vendor;

    // Получаем MD5-хеш в виде слова (WordArray)
    const hash = CryptoJS.MD5(CryptoJS.enc.Utf8.parse(combined));

    // Преобразуем в массив байтов
    const hex = hash.toString(CryptoJS.enc.Hex);
    const bytes = [];

    for (let i = 0; i < hex.length; i += 2) {
        bytes.push(parseInt(hex.substr(i, 2), 16));
    }

    // SQL Server GUID порядок байт:
    // Byte order: 4-2-2-2-6 (но первые три группы в little-endian)
    const toLittleEndian = (arr) => arr.reverse();

    const part1 = toLittleEndian(bytes.slice(0, 4));
    const part2 = toLittleEndian(bytes.slice(4, 6));
    const part3 = toLittleEndian(bytes.slice(6, 8));
    const part4 = bytes.slice(8, 10);
    const part5 = bytes.slice(10, 16);

    const guidBytes = [...part1, ...part2, ...part3, ...part4, ...part5];

    // Форматируем как GUID
    const byteToHex = (b) => b.toString(16).padStart(2, "0");
    const guidHex = guidBytes.map(byteToHex);

    const guid = `${guidHex.slice(0, 4).join("")}-${guidHex.slice(4, 6).join("")}-${guidHex.slice(6, 8).join("")}-${guidHex.slice(8, 10).join("")}-${guidHex.slice(10, 16).join("")}`;

    return guid.toLowerCase();
}

export const updateParamWithoutRerender = (key, value) => {
    const url = new URL(window.location.href);

    if (value.trim() === "") {
        url.searchParams.delete(key);
    } else {
        url.searchParams.set(key, value);
    }
    window.history.pushState({}, "", url.toString());
};

export const clearParamWithoutRerender = (arr) => {
    const url = new URL(window.location.href);
    arr.forEach((key) => url.searchParams.delete(key));
    window.history.replaceState({}, "", url.toString());
};

export const clearAllParamWithoutRerender = () => setTimeout(() => window.history.replaceState({}, "", window.location.pathname || "/"));

export const isMobileDevice = () => {
    const userAgent = window.navigator.userAgent;
    const mobileKeywords = ["Android", "webOS", "iPhone", "iPad", "iPod", "BlackBerry", "Windows Phone", "Opera Mini", "IEMobile", "Mobile"];

    return mobileKeywords.some((keyword) => userAgent.includes(keyword));
};

export function formatPhoneNumber(phone, isModal = false) {
    // Удаляем все нецифровые символы

    if (phone) {
        const cleanPhone = phone.replace(/\D+/g, "");

        if (!cleanPhone.startsWith("7") && !cleanPhone.startsWith("8")) {
            return phone; // Возвращаем оригинальный номер если он не подходит
        }

        if (isModal) {
            return cleanPhone.replace(/^(\d)(\d{3})(\d{3})(\d{2})(\d{2})$/, "+$1 $2 $3-$4-$5");
        }

        return cleanPhone.replace(/^(\d)(\d{3})(\d{3})(\d{2})(\d{2})$/, "+$1 ($2) $3-$4-$5");
    }

    return "";
}

export const isStartScreenWidth = (width) => (window.innerWidth <= width ? true : false);

export const randomNumber = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;

export const getNearValues = (maxValue, range = 16) => {
    if (!maxValue || maxValue <= 0) return [];
    const start = Math.max(1, maxValue - range);
    return Array.from({ length: maxValue - start + 1 }, (_, index) => start + index);
};

export const getNear = (min, max, base, delta = 3) => {
    const value = base + randomNumber(-delta, delta);
    return Math.max(min, Math.min(max, value));
};

export const getAbTestMetrika = (abTest = {}, id = "") => {
    if (abTest && id) {
        for (let [key, value] of Object.entries(abTest)) {
            if (key.split("_").includes(id)) {
                return value;
            }
        }
    }

    return false;
};

export const getCookie = (name) => {
    const cookiesArray = document.cookie.split("; ");
    for (let i = 0; i < cookiesArray.length; i++) {
        const [cookieName, cookieValue] = cookiesArray[i].split("=");
        if (cookieName === name) {
            return cookieValue;
        }
    }
    return null;
};

export const validateEmail = (email) => {
    if (typeof email !== "string") return false;
    const normalizedEmail = email.toLowerCase().trim();

    // Базовая структура: что-то@что-то.что-то
    if (!normalizedEmail.includes("@")) return false;
    const [local, domainFull] = normalizedEmail.split("@");
    if (!local || !domainFull) return false;

    // Проверка домена (оставим вашу логику, но уберём ограничение на длину TLD)
    const domainPattern = /^([\w-]{2,}\.)+[\w-]{2,}$/;
    if (!domainPattern.test(domainFull)) return false;

    // --- Проверка локальной части ---
    const localPattern = /^[a-z0-9][a-z0-9+_.-]*[a-z0-9]$/;
    if (!localPattern.test(local)) return false;

    // Запрет двух точек подряд (или точки рядом с +, _, - — не требуется по ТЗ, но .. точно запрещено)
    if (local.includes("..")) return false;

    // --- Дополнительные проверки (ваши правила) ---
    const domainParts = domainFull.split(".");
    const mainDomain = domainParts[0];

    if (local.length < 2 || mainDomain.length < 2) return false;
    if (local === mainDomain) return false;

    const stopWords = ["test", "asdf", "qwert", "email", "123", "abc", "none", "fake", "null"];
    if (stopWords.some((word) => local.startsWith(word))) return false;

    // Убираем не-буквенно-цифровые символы для анализа повторов (оставляем только a-z0-9)
    const cleanLocal = local.replace(/[^a-z0-9]/g, "");
    const cleanDomain = mainDomain.replace(/[^a-z0-9]/g, "");

    if (cleanLocal.length === 0 || cleanDomain.length === 0) return false;

    // Полностью одинаковые символы (только среди букв/цифр)
    const sameCharOnlyPattern = /^([a-z0-9])\1+$/;
    if (sameCharOnlyPattern.test(cleanLocal) || sameCharOnlyPattern.test(cleanDomain)) return false;

    // Доля самого частого символа > 70%
    const isTooRepetitive = (str) => {
        const freq = {};
        for (const c of str) {
            freq[c] = (freq[c] || 0) + 1;
        }
        const maxCount = Math.max(...Object.values(freq));
        return maxCount / str.length > 0.7;
    };

    if (isTooRepetitive(cleanLocal) || isTooRepetitive(cleanDomain)) return false;

    return true;
};

export const validatePhone = (phone, maskType = "+7 (___) ___-__-__") => {
    const maskValidation = maskType.replace(/[\s\(\)\+-]/g, "");
    const phoneVaildation = phone.replace(/[\s\(\)\+-]/g, "");
    const digitsOnly = phone.replace(/\D/g, "");

    if (digitsOnly.length !== maskValidation.length) return false;

    const repeatedCharPattern = /(\d)\1{6,}/;
    if (repeatedCharPattern.test(phoneVaildation)) return false;

    const isPhoneRF = /^(?:\+7|7|8)(?:[9])\d{9}$/;
    if (!isPhoneRF.test(phoneVaildation)) return false;

    return true;
};

const QUERY_TO_AB_KEY = {
    ab_offers: "abOffers",
    ab_sites: "abSites",
    widgets: "lego",
};

export const parseAbQuery = () => {
    // ?ab_offers=valera_ivi_v1,igor_yandex_v3&ab_sites=site_a_v1,site_b_v2&widgets=ya_v1,b_sample_v2
    const urlParams = new URLSearchParams(window.location.search);
    const result = {
        abOffers: [],
        abSites: [],
        lego: [],
    };

    Object.entries(QUERY_TO_AB_KEY).forEach(([queryKey, abKey]) => {
        const paramValue = urlParams.get(queryKey);

        if (paramValue) {
            result[abKey] = paramValue
                .split(",")
                .map((item) => item.trim())
                .filter(Boolean);
        }
    });

    return { abObject: result };
};
